import { SET_SHAREHOLDER, SET_SHAREHOLDERS } from "../../constants/shareholderConstants";

export const setShareholder = (shareholder) => {
  return {
    type: SET_SHAREHOLDER,
    shareholder,
  };
};

export const setShareholders = (shareholders, filtered = false) => {
  return {
    type: SET_SHAREHOLDERS,
    shareholders,
    filtered,
  };
};
